// Copyright (c) 2026 Isolated Networks. All rights reserved.
// Proprietary and confidential. Unauthorized copying, distribution, or use
// of this file, via any medium, is strictly prohibited.
// SPDX-License-Identifier: LicenseRef-Proprietary

/**
 * Region CLIENTS column count from one /proxy/network/batch-clients row.
 *
 * Matches the Stargate badge's *intent* (VPN-addressed eth + VLAN tunnels,
 * MAC-deduped) but is not a port of processStargateClients: no gateway /
 * self-IP filter, no `d.data` fallback, no preserved vpn_ip from a prior
 * poll. A later success that omits vpn_ip therefore writes 0.
 *
 * @returns {number|null} null when the row is missing or `error` — caller
 *   must skip and keep the last good count. 0 is a real empty poll and
 *   must be written.
 */
function hasVpnIp(c) {
  return !!(c && c.vpn_ip && String(c.vpn_ip).trim());
}

function clientMac(c) {
  return String((c && (c.mac_address || c.mac)) || '').toUpperCase();
}

function ethernetList(ethernet) {
  if (!ethernet) return [];
  if (Array.isArray(ethernet.all_clients)) return ethernet.all_clients;
  if (Array.isArray(ethernet.clients)) return ethernet.clients;
  if (Array.isArray(ethernet)) return ethernet;
  return [];
}

export function countBatchClients(raw) {
  if (!raw || raw.error) return null;
  const vlanList = Array.isArray(raw.vlan && raw.vlan.clients) ? raw.vlan.clients : [];
  const ethList = ethernetList(raw.ethernet);
  const listed = [...ethList, ...vlanList];
  const seen = new Set();
  let n = 0;
  for (const c of listed) {
    if (!hasVpnIp(c)) continue;
    const mac = clientMac(c);
    if (mac) {
      if (seen.has(mac)) continue;
      seen.add(mac);
    }
    n += 1;
  }
  // Incomplete poll: wg enrichment missed every vpn_ip, or vlan-clients
  // timed out (vlan_ok: false) leaving a VLAN-only site looking empty.
  if (raw.vlan_ok === false) return null;
  if (n === 0 && listed.length > 0) return null;
  return n;
}
